(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axe-film"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fit = () => document.querySelectorAll('.axe-size').forEach(el => {
    const top = el.getBoundingClientRect().top + scrollY;
    el.style.setProperty('--axe-fit-top', (top < innerHeight * .5 ? Math.round(top) : 0) + 'px');
  });
  fit(); addEventListener('load', fit); addEventListener('resize', fit);
  document.addEventListener('shopify:section:load', fit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axe-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fit = () => document.querySelectorAll('.axe-size').forEach(el => {
    const top = el.getBoundingClientRect().top + scrollY;
    el.style.setProperty('--axe-fit-top', (top < innerHeight * .5 ? Math.round(top) : 0) + 'px');
  });
  fit(); addEventListener('load', fit); addEventListener('resize', fit);
  document.addEventListener('shopify:section:load', fit);
})();

  } catch(e) { console.error(e); }
})();
})();
